var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EDGE_PAYLOAD_KEY } from '../LinkApiRouter/types/template';
var PII_MATCHES = [
    'user',
    'password',
    'ssn',
    'phone',
    'social_security_number',
    'date_of_birth',
    /details_?table/,
    EDGE_PAYLOAD_KEY,
];
var PII_WITH_LENGTH_OK_MATCHES = ['ssn', 'phone', EDGE_PAYLOAD_KEY];
var checkKeyMatch = function (key, pattern) {
    return key.toLowerCase().match(pattern);
};
var keyInArray = function (key, array) {
    return array.some(function (pattern) { return checkKeyMatch(key, pattern); });
};
var getObfuscatedString = function (k, v) {
    if (keyInArray(k, PII_WITH_LENGTH_OK_MATCHES) && typeof v === 'string') {
        return v.replace(/./g, '*');
    }
    return '???';
};
export default function obfuscateLog(root) {
    if (!root)
        return root;
    if (root.constructor === Array)
        return root.map(function (x) { return obfuscateLog(x); });
    if (root.constructor === Object)
        return Object.entries(root).reduce(function (acc, _a) {
            var _b;
            var k = _a[0], v = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[k] = keyInArray(k, PII_MATCHES)
                ? getObfuscatedString(k, v)
                : obfuscateLog(v), _b)));
        }, {});
    if (typeof root === 'string' && root[0] === '{') {
        try {
            var parsed = JSON.parse(root);
            return JSON.stringify(obfuscateLog(parsed));
        }
        catch (e) {
            return root;
        }
    }
    return root;
}
